// gloss
export const APPLICATION_FIELD_TYPES = {
  SHORT_TEXT: 'shortText',
  LONG_TEXT: 'longText',
  EMAIL: 'email',
  PHONE: 'phone',
  COUNTRY: 'country',
  SINGLE_SELECT: 'single-select',
  MULTI_SELECT: 'multi-select',
  LEGACY_TEXT: 'text',
} as const;

export type ApplicationFieldType =
  (typeof APPLICATION_FIELD_TYPES)[keyof typeof APPLICATION_FIELD_TYPES];

// gloss
const TEXT_LIKE_FIELD_TYPES = [
  APPLICATION_FIELD_TYPES.SHORT_TEXT,
  APPLICATION_FIELD_TYPES.LONG_TEXT,
  APPLICATION_FIELD_TYPES.EMAIL,
  APPLICATION_FIELD_TYPES.PHONE,
  APPLICATION_FIELD_TYPES.COUNTRY,
  APPLICATION_FIELD_TYPES.LEGACY_TEXT,
] as const;

// gloss
const SELECT_FIELD_TYPES = [
  APPLICATION_FIELD_TYPES.SINGLE_SELECT,
  APPLICATION_FIELD_TYPES.MULTI_SELECT,
] as const;

export const isTextLikeFieldType = (responseType: string): boolean =>
  (TEXT_LIKE_FIELD_TYPES as readonly string[]).includes(responseType);

export const isSelectFieldType = (responseType: string): boolean =>
  (SELECT_FIELD_TYPES as readonly string[]).includes(responseType);

// gloss
export const normalizeLegacyTextType = (responseType: string | undefined | null): string => {
  if (!responseType) return APPLICATION_FIELD_TYPES.SHORT_TEXT;
  if (responseType === APPLICATION_FIELD_TYPES.LEGACY_TEXT) {
    return APPLICATION_FIELD_TYPES.SHORT_TEXT;
  }
  return responseType;
};
